import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../components/Button';
import BlogForm from '../components/Blog/BlogForm';
import BreadCrumb from '../components/Breadcrumb';
import * as actions from '../redux/actions/actions-blog';

class addBlog extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {
      seoData: []
    };
  }


  handleSubmit = (FormData) => {
    const SEO = this.state.seoData.length ? this.state.seoData.map((item) => ({ param: item.keyName, value: item.value })) : [];
    this.props.saveBlog({ ...FormData, SEO });
  }

  handleReapter = (data) => {
    this.setState({ seoData: data });
  }

  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Blog" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Blog</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Blog</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <BlogForm
                  onSubmit={this.handleSubmit}
                  repeaterChange={this.handleReapter}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addBlog.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveBlog: PropTypes.func,
  handleReapter: PropTypes.func
};

addBlog.defaultProps = {
  formLoading: null,
  formError: null,
  saveBlog: null,
  handleReapter: null
};

const mapStateToProps = ({ blog }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveBlog: (data) => dispatch(actions.saveBlog(data)),
  setForm: (id) => dispatch(actions.editBlog(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addBlog);
